import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { Router, ResolveEnd, ActivatedRouteSnapshot } from '@angular/router';
// import { AppInsights } from 'applicationinsights-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';
// import { filter } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class MonitorService {
    private appInsights!: ApplicationInsights;
    constructor(private router: Router) { }

    init() {
        this.initAppInsights();
        this.subscribeToRouterEvents();
    }

    trackPageView( name: string, url?: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }, duration?: number) {
        // AppInsights.trackPageView(
        //     name,
        //     url,
        //     this.AddGlobalProperties(properties),
        //     measurements,
        //     duration
        // );

        this.appInsights.trackPageView({
            name,
            uri: url,
            properties: this.AddGlobalProperties(properties),
        })
    }

    trackEvent( name: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number } ) {
        // AppInsights.trackEvent(
        //     name,
        //     this.AddGlobalProperties(properties),
        //     measurements
        // );

        this.appInsights.trackEvent({
            name,
            properties: this.AddGlobalProperties(properties)
        })
    }

    trackError( error: Error, properties?: { [key: string]: string }, measurements?: { [key: string]: number } ) {
        // AppInsights.trackException(
        //     error,
        //     undefined,
        //     this.AddGlobalProperties(properties),
        //     measurements
        // );

        this.appInsights.trackException({
            exception: error,
            properties: this.AddGlobalProperties(properties)
        })
    }

    private AddGlobalProperties(properties?: { [key: string]: string }): {
        [key: string]: string;
    } {
        if (!properties) {
            properties = {};
        }
        return properties;
    }

    setAuthenticatedUserId(userId: string) {
        // AppInsights.setAuthenticatedUserContext(userId);

        this.appInsights.setAuthenticatedUserContext(userId);
    }

    private initAppInsights() {
        // if (environment.appInsights && environment.appInsights.instrumentationKey) {
        //     if (AppInsights && typeof AppInsights.downloadAndSetup === 'function') {
        //         AppInsights.downloadAndSetup(environment.appInsights);
        //     }
        // }

        if (environment.appInsights?.instrumentationKey) {
            this.appInsights = new ApplicationInsights({
            config: {
                    instrumentationKey: environment.appInsights.instrumentationKey,
                    enableAutoRouteTracking: false,
                },
            });

            this.appInsights.loadAppInsights();
        }
    }

    private subscribeToRouterEvents() {
        this.router.events
            .pipe(filter((event: any) => event instanceof ResolveEnd))
            .subscribe((event: ResolveEnd) => {
                const activatedComponent = this.getActivatedComponent(event.state.root);
                if (activatedComponent) {
                    this.trackPageView(
                        `${activatedComponent.name} ${this.getRouteTemplate(
                            event.state.root
                        )}`,
                        event.urlAfterRedirects
                    );
                }
            });
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = '';
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }
}

@Injectable()
export class MonitorErrorHandler extends ErrorHandler {
    constructor(private injector: Injector) {
        super();
    }

    override handleError(error: any): void {
        const authService = this.injector.get(AuthService);
        const router = this.injector.get(Router);
        if (error && error.status === 401) {
            // Ensure that 'error' is not null or undefined before accessing its properties
            const url = router.routerState.snapshot.url;
            localStorage.setItem('redirectUrl', url);
            authService.login();
        }
    }
}
